/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MuyProntoParaIniciarConsulta.css';
import calendario from '../../../../public/images/ic_calendar_grey.png';
import redirectTo from '../../../utils/redirectTo';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';

class MuyProntoParaIniciarConsulta extends React.Component {
  constructor(props) {
    super(props);
    this.volverAConsultaTurnos = this.volverAConsultaTurnos.bind(this);
  }

  volverAConsultaTurnos() {
    this.props.hideMuyProntoParaIniciarLaConsulta();
    redirectTo('/telemedicina/solicitud-turnos');
  }

  render() {
    const arrFecha = this.props.fecha.split('-');
    const arrHora = arrFecha[2].split(' ');
    const year = arrFecha[0];
    const month = arrFecha[1];
    const day = arrHora[0];
    const hour = arrHora[1];
    return (
      <div className={s.msg}>
        <div className="media">
          <img className="mr-3" src={calendario} alt={'calendario'} />
          <div className={` ${s.bold} media-body`}>
            <div className={`mt-0 font-weight-bold`}>
              Todavía es muy pronto, tu consulta se encuentra agendada para el
              {` ${day}-${month}-${year} ${hour}`} Hs.
            </div>
            Por favor, regresá unos minutos antes de tu horario de atención.{' '}
            <br />
            <button
              onClick={() => this.volverAConsultaTurnos()}
              className={`${s.boton_volver}`}
            >
              <i className="glyphicon glyphicon-chevron-left" /> Volver a
              solicitud de turnos
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, telemedicinaActions)(
  withStyles(s)(MuyProntoParaIniciarConsulta),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/MuyProntoParaIniciarConsulta/MuyProntoParaIniciarConsulta.js